


/**
 * Google Map
 */
var Map, OverlayView, AdvancedMarkerElement, Size, Point; // GMaps classes
var maps = {};
var markerManagers = {};

async function loadGoogleMapsLibraries() {
  try {
      // Charger toutes les bibliothèques nécessaires en parallèle
      const [mapsModule, markerModule, coreModule] = await Promise.all([
          google.maps.importLibrary("maps"),
          google.maps.importLibrary("marker"),
          google.maps.importLibrary("core")
      ]);

      // Extraire les classes et les assigner à des variables globales
      Map = mapsModule.Map;
      AdvancedMarkerElement = markerModule.AdvancedMarkerElement;
      ({ Size, Point } = coreModule);

      console.log("Google Maps libraries loaded successfully.");
  } catch (error) {
      console.error("Error loading Google Maps libraries:", error);
      // Gérer l'erreur en affichant un message ou en prenant une action appropriée
  }
}


window.onCloseMarkerTooltip = function(e)
{
    let btn = e.target;
    let winWrapper = findAncestor(btn, '[data-marker-id]');
    let markerID = winWrapper.dataset.markerId;

    // Get default marker manager with "map" id
    // TODO : handle various ones
    let markersManager = markerManagers['map'];
    let markerGroups = markersManager.markers;

    // Search the related marker by its id
    // Parse all marker groups
    for(var slug in markerGroups)
    {
        let markerGroup = markerGroups[slug];

        // Parse all markers in the group
        for(var id in markerGroup.markers)
        {
            if(id === markerID)
            {
                // Close the infowindow
                let closeMarker = markerGroup.markers[id];
                closeMarker.infowindow.close();
                return;
            }
        }
    }

    console.log('Close infowindow', window.pois[markerID], markerID, winWrapper);

}


/**
 * Init a new Google Maps instance
 * 
 * @param {string} id The map id
 * @param {number} latCenter The default latitude
 * @param {number} lngCenter The default longitue
 * @param {int} zoom  The default zoom level
 * 
 * @returns {google.maps.Map}
 */
window.initMap = function(id='map', latCenter=48.864716, lngCenter=2.349014, zoom=15)
{
    // const { Map } = await google.maps.importLibrary("maps");
/* 
    let mapStyles = [
        {
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffeb3b"
            }
          ]
        }
      ]; */

    // maps[id] = new google.maps.Map(document.getElementById(id), {
    maps[id] = new Map(document.getElementById(id), {
        center: { lat: latCenter, lng: lngCenter },
        zoom: zoom,
        mapId: "4504f8b37365c3d0",
        mapTypeControl: false // Disable map/satelite view box
    });


    // Créer un OverlayView personnalisé
    /* class FullscreenOverlay extends OverlayView {
        constructor() {
            super();
        }

        onAdd() {
            const layer = document.createElement('div');
            layer.className = 'map-overlay';

            // Ajout du div overlay à la carte
            const panes = this.getPanes();
            panes.overlayLayer.appendChild(layer);
        }

        draw() {
            // Rien à redessiner en permanence pour ce type d'overlay
        }
    }

    // Instanciation et ajout de l'overlay à la carte
    const overlay = new FullscreenOverlay();
    overlay.setMap(map); */


    // Créer un OverlayView personnalisé
    /* const overlay = new google.maps.OverlayView();

    // Ajouter l'overlay lorsque la carte est prête
    overlay.onAdd = function () {
        const layer = document.createElement('div');
        layer.className = 'map-overlay';

        // Ajout du div overlay à la carte
        const panes = this.getPanes();
        panes.overlayLayer.appendChild(layer);
    };

    // Redimensionner et positionner le div correctement
    overlay.draw = function () {
        console.log('overlay draw');
        // Aucun redimensionnement spécifique nécessaire ici
    }; */

    return maps[id];
}


function getMap(id)
{
    return maps[id];
}


/**
 * Get a marker manager
 * 
 * @param {string} id The map id
 * 
 * @returns {MarkerManager}
 */
function getMarkerManager(id)
{
    return markerManagers[id];
}


/**
 * Build a Google map with POI (Points Of interest) group managment
 * 
 * @param {string}  id      The map wrapper id
 * @param {array}   pois    The POIs list
 * @param {array}   groups  The POIs groups list
 */
window.initPOIMap = function(id, pois, groups)
{
    loadGoogleMapsLibraries().then(() => {
/*         google.maps.event.addDomListener(window, 'load', function() {
            alert('map Loaded');
        }); */
        let map = initMap(id);

        let markerManager = new MarkerManager(map);
    
        setupMapTogglebuttons(id);
    
        // Setup all available groups
        for(let i in groups)
        {
            let group = groups[i];
            let isProgramme = (group.id === 0);
    
            let groupIconOptions = {
            };
    
            // Build icon
            if(group.icon !== null)
            {
                let markerContainer = document.createElement('div');
                markerContainer.className = 'marker-container';
        
                let markerIcon = document.createElement('div');
                let iconW = group.icon.size[0]+'px';
                let iconH = group.icon.size[1]+'px';
                markerIcon.className = 'marker-icon';
                markerIcon.style.backgroundImage = 'url('+group.icon.url+')';
                markerIcon.style.backgroundSize = iconW+' '+iconH;
                markerIcon.style.width = iconW;
                markerIcon.style.height = iconH;

                markerContainer.appendChild(markerIcon);
                groupIconOptions.content = markerContainer;
            }

            // Create the marker group & listen to its visibility changes
            var markerGroup = markerManager.createGroup(group.slug, groupIconOptions);
            // console.log('Marker group', groupIconOptions, group.id, isProgramme, group);
            markerGroup.setVisibleStatus(isProgramme);
            markerGroup.addEventListener('afterVisibilityChange', (e) => { updateMapView(markerManager); });
        }
    
        // Add Markers into groups
        for(let i in pois)
        {
            let poi = pois[i];
    
            for(let j in poi.categories)
            {
                let category = poi.categories[j];
                let mGroup = markerManager.addMarker( poi.lat, poi.lng, category.slug, {}, poi.id);
    
                if(poi.tooltip)
                    pois[i]['marker'] = mGroup.setMarkerTooltip(poi.id, poi.tooltip);
            }
        }
    
        maps[id] = map;
        markerManagers[id] = markerManager;

        /* const overlayDiv = document.createElement('div');
        overlayDiv.className = 'map-overlay';
        overlayDiv.style.backgroundColor = "#FF0000";
        overlayDiv.style.position = "absolute";
        overlayDiv.style.left = 0;
        overlayDiv.style.right = 0;
        overlayDiv.style.top = 0;
        overlayDiv.style.bottom = 0;
        overlayDiv.style.width = "100%";
        overlayDiv.style.height = "100%";
        overlayDiv.style.zIndex = 500;

        const customOverlay = new google.maps.OverlayView();

        customOverlay.onAdd = function () {
            const panes = this.getPanes();
            panes.overlayLayer.appendChild(overlayDiv);
        };

        customOverlay.setMap(map);
        console.log('Add custom overlay', customOverlay, overlayDiv); */

        updateMapView(markerManager);
    });
}



/**
 * Adjust the map zoom/bounds according to visible markers
 * 
 * @param {MarkerManager} manager 
 */
function updateMapView(manager)
{
    let markers     = manager.getVisibleMarkers();
    let map         = manager.getMap();
    let defaultZoom = 13;

    if(markers.length <= 1)
    {
        // Prevent to zoom to much if there's only 1 marker
        google.maps.event.addListener(map, 'zoom_changed', function() {
            let zoomChangeBoundsListener = google.maps.event.addListener(map, 'bounds_changed', function(event) {
                    if (this.getZoom() > defaultZoom && this.initialZoom == true) {
                        // Change max/min zoom here
                        this.setZoom(defaultZoom);
                        this.initialZoom = false;
                    }
                google.maps.event.removeListener(zoomChangeBoundsListener);
            });
        });
        map.initialZoom = true;
    }

    // console.log('trigger fitbounds', manager, manager.map);
    manager.fitBounds();
}



/**
 * Set visible map markers group(s), the others are hidden
 * 
 * @param {string}          mapID   The map id
 * @param {string|array}    groups  One or more groups name/slug
 */
function setMapMarkerGroupsVisibility(mapID, groups, isVisible)
{
    let manager = getMarkerManager(mapID);
    let allGroups = manager.getMarkersGroups();

    if(typeof groups === 'string')
        groups = [groups];

    // Change group visibility (visible or hidden)
    for(let i in groups)
    {
        let groupName = groups[i];
        let group = manager.getMarkersGroup(groupName);
        group.setVisibleStatus(isVisible);
    }
}


/**
 * Setup markers toggle buttons
 * 
 * @param {string} mapID    The map ID
 */
function setupMapTogglebuttons(mapID)
{
    let btns = document.querySelectorAll('input[data-toggle-markers][data-map-id='+mapID+']');

    btns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            let mapID   = btn.dataset.mapId;
            let group   = btn.dataset.toggleMarkers;
            let groups = group.split(',');

            setMapMarkerGroupsVisibility(mapID, groups, e.target.checked);
        });
    })
}



// **********************************************************


/**
 * Class MarkerManager
 * 
 * Convenient tool to manage Google Maps as groups
 * 
 * @param {google.maps.Map} map 
 */
class MarkerManager extends EventTarget
{
    constructor(map)
    {
        super();

        this.markers = {};
        this.map = map;
        this.self = this;
    }



    /**
     * Get the map
     * 
     * @returns {google.maps.Map}
     */
    getMap()
    {
        return this.map;
    }



    /**
     * 
     * @param {string} name The group name
     * 
     * @returns {MarkerGroup}
     */
     getMarkersGroup(name)
    {
        return (this.markers[name]) ? this.markers[name] : null;
    }


    /**
     * Get all the marker groups
     * 
     * @returns array
     */
     getMarkersGroups()
    {
        return this.markers;
    }


    /**
     * Create a new markers group
     * 
     * @param {string}  name        The group name
     * @param {object}  options     The default markers options
     * @param {boolean} reset       True to reset the group if it's already exists
     * 
     * @returns {MarkerGroup}   The created group
     */
     createGroup(name, options={}, reset=false)
     {
 
        if(!this.markers[name] || reset === true)
        {
            // console.log('Create marker group', this.map);
            this.markers[name] = new MarkerGroup(this.map, name, options);
        }
        
        return this.markers[name];
    }



    /**
     * Adjust the map view to display all visible markers
     * 
     * @param {int} padding The frame padding
     */
    fitBounds(padding=50)
    {
        let bounds = this.getVisibleBounds();
        this.map.fitBounds(bounds, padding);
    }



    /**
     * Get visible markers bounds
     * 
     * @returns {google.maps.LatLngBounds}
     */
    getVisibleBounds()
    {
        let bounds = new google.maps.LatLngBounds();
        let markers = this.getVisibleMarkers();

        for(let i in markers)
        {
            let marker = markers[i];
            // let position = marker.getPosition();
            let position = marker.position;
            bounds.extend(position);
        }

        return bounds;
    }



    /**
     * Get all visible markers
     * 
     * @returns {array}
     */
    getVisibleMarkers()
    {
        let markers = [];
        let groups = this.getVisibleGroups();

        // Merge all markers
        groups.forEach(group => {
            markers = markers.concat(Object.values(group.getMarkers()));
        });

        return markers;
    }



    /**
     * Get all visible marker groups
     * 
     * @returns {array}
     */
    getVisibleGroups()
    {
        let visibleGroups = [];

        for(const groupName in this.markers)
        {
            let group = this.markers[groupName];

            if(group.visible)
                visibleGroups.push(group);
        };

        return visibleGroups;
    }



    /**
     * Add an already created marker to a group
     * 
     * @param {string}              groupName 
     * @param {google.maps.Marker}  marker 
     */
     /*addMarkerToGroup(groupName, marker, id=null)
    {
        this.markers[groupName].addMarker(marker);
    }*/



    /**
     * Create a new marker and add it into a group
     * 
     * @param {float}   lat         Latitude
     * @param {float}   lng         Longitude
     * @param {string}  groupName   The name of the group
     * @param {object}  options     The marker options
     * 
     * @returns {MarkerGroup}
     */
     addMarker(lat, lng, groupName, options={}, id=null)
    {
        let group = this.createGroup(groupName);
        group.createMarker(lat, lng, options, id);

        return group;
    }


    /**
     * Toggle the visibility of a marker groups
     * 
     * @param {string} groupName 
     */
    toggleGroupVisibility(groupName)
    {
        let group = this.getMarkersGroup(groupName);

        if(group)
        {
            group.toggleVisibility();
        }
    }
  }



  /**
   * Class MarkerGroup
   * 
   * Handle multiple markers
   * 
   */
  class MarkerGroup extends EventTarget
  {

    /**
     * @param {google.maps.Map}   map     The assigned map
     * @param {string}            name    The group name
     * @param {object}            options The default marker options
     */
    constructor(map, groupName, options={}) {
        super();

        this.name = groupName;
        this.map = map;
        this.markers = {};
        this.infowindow = [];
        this.visible = true;
        this.defaultOptions = options;
        this.id = this.generateId();

        if(options)
            this.setOptions(options);
    }


    generateId() {
        var S4 = function() {
           return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        };
        return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    }


    /**
     * Get the group markers
     * 
     * @returns array
     */
    getMarkers()
    {
        return this.markers;
    }



    /**
     * Get a marker
     * 
     * @param {*} id 
     * 
     * @returns google.maps.Marker
     */
    getMarker(id)
    {
        return (this.markers[id]) ? this.markers[id] : null;
    }



    /**
     * Set marker infobubble content
     * 
     * @param {*} markerID 
     */
    setMarkerTooltip(markerID, content, event='click')
    {
        const marker = this.getMarker(markerID);
        // let this.infowindow

        /* let parser = new DOMParser();
        let contentDoc = parser.parseFromString(content, 'text/html'); */
        let iwContent = '<div class="iw-wrapper" data-marker-id="'+markerID+'">'+content+'</div>'
        // contentDoc.firstChild.setAttribute('data-marker-id', markerID);
        
        const infowindow = new google.maps.InfoWindow({
            content: iwContent,
        });
        /* google.maps.event.addListener(infowindow, 'domready', function() {
            // console.log('domready infowindow');

            document.querySelectorAll('.tt-close').forEach((el) => el.addEventListener("click", function(event){
                console.log('custom close click', el, this, event);
                infowindow.close();
            }));
            }); */
/* 
        infowindow.addListener('closeclick', function() {
            alert('infoW close click');
        }); */
            
        marker.addListener(event, () => {
            infowindow.open(this.map, marker);
            // console.log(infowindow, document.querySelectorAll('.tt-close'));
        });

        marker.infowindow = infowindow;

        return marker;
    }


    /**
     * Get the group bounds
     * 
     * @returns google.maps.LatLngBounds
     */
     getBounds()
    {
        let bounds = new google.maps.LatLngBounds();

        for(let i in this.markers)
        {
            let marker = this.markers[i];
            let position = marker.getPosition();
            bounds.extend(position);
        }

        return bounds;
    }



    /**
     * Set markers visibility
     * 
     * @param {boolean} value The markers visiblity
     * @param {boolean} force Force the visibility update
     */
    setVisibleStatus(value, force)
    {
        if(typeof value !== 'boolean' || (this.visible === value && force !== true))
            return;

        this.triggerEvent('beforeVisibilityChange', {'newStatus': value});

        for(let i in this.markers)
        {
            let marker = this.markers[i];
            
            // TODO determines why some calls are made a second time without content
            if(marker.content !== undefined)
            {
                marker.content.style.display = (value) ? 'block' : 'none';
            }

            if(!value && marker.infowindow)
            {
                // If hide group : close the markers infowindow
                marker.infowindow.close();
            }

            marker.visible = value;
        }

        this.visible = value;
        this.triggerEvent('afterVisibilityChange', {'newStatus': value});
    }



    /**
     * Toggle markers visibility
     * 
     * @returns {boolean} The new visibility state
     */
     toggleVisibility()
    {
        if(this.visible)
            this.hide();
        else
            this.display();

        return this.visible;
    }


    /**
     * Display the markers
     */
    display()
    {
        this.setVisibleStatus(true);
    }


    /**
     * Hide the markers
     */
    hide()
    {
        this.setVisibleStatus(false);
    }



    /**
     * Adjust the view to display all markers
     * 
     * @param {number} padding in px
     */
     fitBounds(padding=0)
    {
        let bounds = this.getBounds();
        this.map.fitBounds(bounds, padding);
    }



    /**
     * Set default markers options
     * 
     * @param {object} options Default markers options
     */
     setOptions(options)
    {
        this.defaultOptions = options;

        if(options.visible !== undefined)
            this.visible = options.visible;
    }


    /**
     * Create a new marker and add it to the group
     * 
     * @param {float}   lat         Latitude
     * @param {float}   lng         Longitude
     * @param {object}  options     The marker options
     */
    createMarker(lat, lng, options={}, id=null)
    {
        // Build marker options
       let markerOptions = Object.assign(this.defaultOptions, options);
        markerOptions.position = {lat: lat, lng: lng};
        markerOptions.map = this.map;


        // If the marker content is DomElement, need to be cloned to be used in multiple instances
        if(this.defaultOptions.content instanceof HTMLElement)
        {
            markerOptions.content = this.defaultOptions.content.cloneNode(true);
        } 

        // Build/add marker to the group
        var marker = new AdvancedMarkerElement(markerOptions);
        this.addMarker(marker, id);
        this.setVisibleStatus(this.visible, true);
    }



    /**
     * Assign an existing marker to this group
     * 
     * @param {google.maps.Marker}  marker 
     */
     addMarker(marker, id=null)
    {
        if(id == null)
            id = Math.floor(Math.random() * 100000);

        this.markers[id] = marker;
    }



    /**
     * Trigger a custom event
     * 
     * @param {string} name The event name to trigger
     * @param {object} data Detail atached data
     * @param {object} target The object from whom to trigger the event
     */
    triggerEvent(name, data={}, target=this)
    {
        const event = new CustomEvent(name, {detail: data});
        target.dispatchEvent(event);
    }
  }